import { SlideDeck, SlidesObject } from '../../../lib/slides/types'

export const defaultState: SlidesObject = {
  slideDecks: [] as SlideDeck[],
  activeDeck: null,
  isUploading: false,
  uploadProgress: 0,
  cancelToken: null,
  processingProgress: 0,
  pendingSlidesId: null,
  hasError: false,
  error: null,
  pendingFile: null,
  setAsFeatureImage: true,
  featureImageRequested: null,
  selectedSlide: null,
  selectedSlideStep: 0,
  apiVersion: null,
  isProcessing: false,
  showSlidesRemoveConfirmModal: false
}
